export default __webpack_public_path__ + "static/media/favorite.17e37281.svg";